import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { StepRoutes } from './step/step-routes';

const WizardOverview = lazy(() => import('./wizard-overview'));
const WizardCreate = lazy(() => import('./wizard-create/wizard-create.component'));
const WizardDetail = lazy(() => import('./wizard-detail/wizard-detail.component'));
const WizardUpdate = lazy(() => import('./wizard-update/wizard-update.component'));

export function WizardRoutes() {
    const StepRoute = StepRoutes();

    return (
        <Route path='wizards'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <WizardOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <WizardCreate />
                    </AsyncComponent>
                }
            />

            <Route path=':wizardId'>
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <WizardUpdate />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <WizardDetail />
                        </AsyncComponent>
                    }
                />
                {StepRoute}
            </Route>
        </Route>
    );
}
